import { SkeletonLoading } from '@ajaibid/components';
import { generateSequentialArray } from '@ajaibid/utils';
import { css } from '@emotion/css';
import React from 'react';

const styDetail = css`
  display: flex;
  gap: 30px;
  padding: 12px;

  > div {
    display: flex;
    gap: 8px;
    flex-direction: column;

    > div {
      display: flex;
      gap: 8px;
      white-space: nowrap;

      > :first-child {
        font-weight: 700;
      }
    }
  }
`;

export default function LoadingDetail() {
  return (
    <section className={styDetail}>
      {/* 3 Section */}
      {generateSequentialArray(3).map(() => (
        <div>
          {/* 2 Row */}
          {generateSequentialArray(2).map(() => (
            <div>
              <span>
                <SkeletonLoading height={20} width={60} />
              </span>
              <span>
                <SkeletonLoading height={20} width={140} />
              </span>
            </div>
          ))}
        </div>
      ))}
    </section>
  );
}
